var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['notification-dot', 'attention-dot', { 'is-still': _vm.still }],style:({ height: `${_vm.size}px`, width: `${_vm.size}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }